<template>
  <v-col>
    <v-col cols="12">
      <v-form>
        <v-text-field v-model="group.name" label="Название"></v-text-field>
        <v-text-field v-model="group.description" label="Опиисание"></v-text-field>
        <SiteSelect
          @site-selected="siteSelected"
          :site="isEdit ? group.site_key : $attrs.site_key"
        ></SiteSelect>
        <v-checkbox
          v-if="$attrs.site_key === ''"
          v-model="group.is_party_structure"
          label="Структура партии"
        ></v-checkbox>
        <v-checkbox
          v-if="$attrs.site_key === ''"
          v-model="group.is_election_2024"
          label='Во вкладку "ЕДГ 2024"'
        ></v-checkbox>
        <v-btn color="primary" @click="save">Сохранить</v-btn>
        <v-btn color="error" v-if="isEdit" @click="remove">Удалить</v-btn>
      </v-form>
    </v-col>

    <v-col cols="12" v-if="isEdit">
      <v-col column wrap>
        <v-subheader> Состав группы</v-subheader>
        <list-view
          :with-sites="false"
          :color="'#538DCB'"
          :site="group.site_key"
          :items="group.members"
          :items-name="`groups/${group.id}/members`"
          :edit-item="'members_edit'"
          :avatar-url="'image.sizes.50'"
          :description-field="'post'"
          :title-field="'name'"
          @remove-item="updateData"
        ></list-view>
      </v-col>
      <v-btn dark bottom right fab color="secondary" @click="modal = true">
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-col>
    <v-dialog v-model="modal" max-width="500px">
      <v-card>
        <v-card-text class="text-lg-center">
          <SiteSelect @site-selected="memberSiteSelected" :site="memberSite"></SiteSelect>
          <v-text-field v-model="memberSearch" label="Поиск"></v-text-field>
          <v-row v-if="membersList">
            <transition-group
              name="slide-x-transition"
              tag="div"
              role="list"
              class="v-list v-list-two-line"
            >
              <v-list-item v-for="m in membersList" :key="m.id" avatar>
                <v-list-item-avatar v-if="m.image.sizes">
                  <img :src="m.image.sizes['50']" />
                </v-list-item-avatar>
                <v-list-item-content style="cursor: pointer" @click="addMember(m.id)">
                  <v-list-item-title v-html="m.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="m.post"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </transition-group>
          </v-row>
        </v-card-text>
        <v-card-text>
          <Member :is-edit="false" @memberUpdate="memberUpdate"></Member>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-lg-center">
          <v-col cols="12" align-self-center>
            <v-btn color="secondary" flat @click="modal = false">Закрыть</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import SiteSelect from '@/components/SiteSelect'
import Member from '@/components/Member'
import ListView from '@/components/ListView'

export default {
  name: 'groups_edit',
  components: { Member, SiteSelect, ListView },
  mixins: [],
  data() {
    return {
      memberSearch: '',
      membersList: [],
      modal: false,
      memberSite: '',
      group: {
        name: '',
        description: '',
        sort: 0,
        is_party_structure: false,
        is_election_2024: false,
        site_key: '',
      },
    }
  },
  computed: {
    isEdit() {
      return this.$route.name === 'members_groups_edit'
    },
  },
  watch: {
    memberSearch(val) {
      this.searchMember()
    },
    memberSite(val) {
      this.searchMember()
    },
  },

  mounted() {
    if (this.isEdit) {
      this.updateData()
    }
  },
  methods: {
    siteSelected(e) {
      this.group.site_key = e.key
    },
    memberSiteSelected(e) {
      this.memberSite = e.key
    },
    updateData() {
      this.axios({ url: `/v1/groups/${this.$route.params.id}`, method: 'get' })
        .then((resp) => {
          this.group = resp.data || {}
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    save() {
      let url = '/v1/groups'
      let method = 'post'
      if (this.isEdit) {
        url = `/v1/groups/${this.$route.params.id}`
        method = 'patch'
      }
      this.axios({ url: url, method: method, data: this.group })
        .then((resp) => {
          this.group = resp.data
          this.showSnackbar('Сохранено', 'green')
          if (!this.isEdit) {
            this.$router.push({
              name: 'members_groups_edit',
              params: { id: this.group.id },
            })
          }
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },

    remove() {
      if (!this.isEdit) {
        return
      }
      this.axios({ url: `/v1/groups/${this.$route.params.id}`, method: 'delete' })
        .then((resp) => {
          this.showSnackbar('Удалено', 'green')
          this.$router.push({ name: 'members_groups' })
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    addMember(memberId) {
      if (!this.isEdit) {
        return
      }
      const data = { id: memberId }
      this.axios({
        url: `/v1/groups/${this.group.id}/add-member`,
        method: 'post',
        data: data,
      })
        .then((resp) => {
          this.updateData()
          this.modal = false
          this.showSnackbar('Добавлено', 'green')
        })
        .catch((err) => {
          this.$log.error('error add member', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    memberUpdate(member) {
      this.addMember(member.id)
    },
    deleteMember(memberId) {
      if (!this.isEdit) {
        return
      }
      const data = { id: memberId }
      this.axios({
        url: `/v1/groups/${this.group.id}/delete-member`,
        method: 'delete',
        data: data,
      })
        .then((resp) => {
          this.updateData()
        })
        .catch((err) => {
          this.$log.error('error delete member', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    searchMember() {
      if (!this.memberSearch) {
        this.membersList = []
        return
      }

      this.axios({
        url: '/v1/members',
        method: 'get',
        params: { q: this.memberSearch, site_key: this.memberSite },
      })
        .then((resp) => {
          const data = resp.data
          this.membersList = data ? data : []
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updateSort(id, sort) {
      this.axios({
        url: `/v1/groups/${this.group.id}/members/${id}/sort`,
        method: 'post',
        data: { sort: sort },
      })
        .then((resp) => {
          this.$log.error('updated sort', resp)
        })
        .catch((err) => {
          this.$log.error(err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    moveUp(i) {
      const members = [...this.group.members]
      members.swap(i, i - 1)
      for (let i = 0; i < members.length; i++) {
        members[i].sort = i
        this.updateSort(members[i].id, i)
      }
      this.group.members = members
    },
    moveDown(i) {
      const members = [...this.group.members]
      members.swap(i, i + 1)
      for (let i = 0; i < members.length; i++) {
        members[i].sort = i
        this.updateSort(members[i].id, i)
      }
      this.group.members = members
    },
  },
}
</script>

<style scoped lang="scss">
.member-search-item {
  cursor: pointer;
}

.member {
  position: relative;
  padding: 10px;
}

.member_delete {
  cursor: pointer;
  color: indianred;
  position: absolute;
  z-index: 5;
  top: 10px;
  right: 10px;

  &:hover {
    color: red;
  }
}

.member__name {
  cursor: pointer;
}
</style>
